import { normalize as normalizr } from 'normalizr';
import { compose, map, prop } from 'ramda';
import { ERROR } from 'translations';
import { ensureArray } from 'yafrpl/arrays';

import { getErrorObject } from '../../helpers/error';
import { Documents } from '../../schema/prismic';
import { convertTypeToFailure, oneOfLoadSuccessTypes } from '../common';

const schemaToType = ({ id, schema: type }) => ({ type, id });

const applyNormalizr = (payload) => ({
  result: [],
  ...normalizr(ensureArray(payload), Documents),
});

const addType = (payload) => ({
  ...payload,
  result: map(schemaToType, prop('result', payload)),
});

export const getEntities = compose(addType, applyNormalizr);

const convertResults = (action) => {
  const { type, payload } = action;

  let res;
  try {
    res = {
      ...action,
      payload: getEntities(payload),
    };
  } catch (error) {
    res = {
      ...action,
      type: convertTypeToFailure(type),
      payload: getErrorObject(error, ERROR.ERROR_CONVERTING_DOC),
    };
  }

  return res;
};

export default (/* store */) => (next) => (action) => {
  const { type } = action;
  if (oneOfLoadSuccessTypes(type)) {
    return next(convertResults(action));
  }

  return next(action);
};
